import { Button } from "antd";
import React, { useEffect, useState } from "react";
import SisLoader from "../../../../widgets/loader";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import AddCompressorModal from "../components/AddCompressorModal";
import CompressorTable from "../components/CompressorRow";

function ShipCompressorDetails({ id, onSuccess }) {
  const [loader, set_loader] = useState(false);
  const [FilteredData, setFilteredData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [responeData, setResponeData] = useState({});
  const [errors, set_errors] = useState({});

  const LIST_API = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("ship_id", id);
    try {
      post(ApiURL.list_compressor_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.response_data);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
    }
  };

  useEffect(() => {
    LIST_API();
  }, []);

  const ADD_API = async (data) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("compressor_model", data?.model);
      FORM_DATA.append("compressor_make", data?.make);
      FORM_DATA.append("title", data?.title);
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("selected_parameters", JSON.stringify(data?.selectedParams));
      FORM_DATA.append("other_parameters", JSON.stringify(data?.customParams));

      const res = await post(ApiURL.add_compressor_details_com, FORM_DATA);

      if (res?.status === true) {
        SuccessToast("Compressor Details Saved!", "Compressor Details Successfully Added!!");
        setIsModalOpen(false);
        LIST_API();
        if (onSuccess) onSuccess();
      } else {
        const rawErrors = res?.errors || res?.response?.data?.errors || {};
        const transformedErrors = Array.isArray(rawErrors)
          ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
          : rawErrors;
        set_errors(transformedErrors);
      }
    } catch (error) {
      console.error("API Error:", error?.response?.data || error.message || error.toString());
    } finally {
      set_loader(false);
    }
  };

  const UPDATE_API = (data) => {
    set_loader(true);

    // Check if data is defined
    if (!data) {
      console.error("Data is undefined or null!");
      return;
    } // console.table([compressor_model, compressor_make, title, item?.id, ship_id]);
    try {
      set_loader(true);
      const FORM_DATA = new FormData();
      FORM_DATA.append("compressor_model", data?.model);
      FORM_DATA.append("compressor_make", data?.make);
      FORM_DATA.append("title", data?.title);
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("selected_parameters", JSON.stringify(data?.selectedParams || []));
      FORM_DATA.append("other_parameters", JSON.stringify(data?.customParams || []));
      FORM_DATA.append("id", data?.id);
      FORM_DATA.append("request_type", "add-edit");

      post(ApiURL.ship_compressor_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("success", res?.message);
          LIST_API();
          setIsModalOpen(false);
          set_loader(false);
        } else {
          set_loader(false);
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } catch (error) {
      set_loader(false);
      ErrorToast("Error Occurred", "There was an error during registration.");
    }
  };

  const VIEW_API = async (data) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("id", data?.id);
      FORM_DATA.append("request_type", "view");
      post(ApiURL.ship_compressor_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setResponeData(res?.compressor_data);
          setIsModalOpen(true);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
          set_loader(false);
        }
      });
    } finally {
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <h3 style={{ marginTop: "15px", marginBottom: "15px" }}>Compressor Information </h3>
        <Button
          type="primary"
          onClick={showModal}
          style={{ position: "absolute", right: "0px", top: "-10px" }}
        >
          Add Compressor
        </Button>
        <AddCompressorModal
          visible={isModalOpen}
          onOk={(data) => {
            if (responeData?.id) {
              UPDATE_API({ ...data, id: responeData.id });
            } else {
              ADD_API(data);
            }
          }}
          onCancel={() => {
            setIsModalOpen(false);
            setResponeData({});
            set_errors({});
          }}
          responeData={responeData}
          errors={errors}
        />

        {loader ? (
          <SisLoader />
        ) : (
          <>
            {FilteredData?.length > 0 ? (
              <>
                <CompressorTable data={FilteredData} onEdit={(row) => VIEW_API(row)} />
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
}

export default ShipCompressorDetails;
